document.addEventListener("DOMContentLoaded", () => {
  const modalEl = document.getElementById("CountryChangeModal");
  if (modalEl) modalEl.removeAttribute("open");

  const confirmBtn = modalEl?.querySelector('[data-action="confirm-country-change"]');
  const cancelBtn  = modalEl?.querySelector('[data-action="cancel-country-change"]');

  function getCurrentCountryCode(scopeEl) {
    const localInput = scopeEl?.closest('localization-form, .disclosure')?.querySelector('input[name="country_code"]');
    return (localInput?.value || document.querySelector('input[name="country_code"]')?.value || 'US').toUpperCase();
  }

  const beforeCountryChange =
      typeof window.beforeCountryChange === "function" ? window.beforeCountryChange : null;

  let pendingAction = null;
  let userConfirmed = false;
  let atcLockAcquired = false;
  let atcLockTimerId = null;
  const ATC_LOCK_TIMEOUT_MS = 15000;

  function acquireAtcLock() {
    if (atcLockAcquired) return;
    try {
      window.__hbAtcLock?.increment?.();
      atcLockAcquired = true;
      atcLockTimerId = window.setTimeout(releaseAtcLock, ATC_LOCK_TIMEOUT_MS);
    } catch (_) {}
  }
  function releaseAtcLock() {
    if (!atcLockAcquired) return;
    if (atcLockTimerId) clearTimeout(atcLockTimerId);
    atcLockTimerId = null;
    try {
      window.__hbAtcLock?.decrement?.();
    } catch (_) {}
    atcLockAcquired = false;
  }

  function openCountryModal(action, opener) {
    pendingAction = action;
    userConfirmed = false;

    const opensFromMobileDrawer =  opener?.closest(".header-navigation__mobile-drawer");

    if (opensFromMobileDrawer) {
      document.dispatchEvent(new CustomEvent("country-change-modal:open"));
    }

    modalEl?.show?.(opensFromMobileDrawer ? null : opener || document.activeElement);
  }

  async function executePendingAction() {
    if (!userConfirmed || !pendingAction) return;

    if (beforeCountryChange) {
      await beforeCountryChange();
    }

    if (pendingAction.type === 'url') {
      window.location.assign(pendingAction.url);
      return;
    }

    if (pendingAction.type === 'form') {
      const { form, input, code } = pendingAction;
      if (form && input && code) {
        input.value = code;
        form.submit();
      }
    }
  }

  confirmBtn?.addEventListener("click", async () => {
    if (!pendingAction) return;
    userConfirmed = true;
    acquireAtcLock();
    confirmBtn.disabled = true;
    confirmBtn.setAttribute("aria-busy", "true");

    try {
      await executePendingAction();
    } catch (err) {
      console.error("[CountryChange] pre-navigation failed:", err);
      userConfirmed = false;
      confirmBtn.disabled = false;
      confirmBtn.removeAttribute("aria-busy");
      releaseAtcLock();
    }
  });

  cancelBtn?.addEventListener("click", () => {
    userConfirmed = false;
    pendingAction = null;
    modalEl?.hide?.();
    releaseAtcLock();
  });

  modalEl?.addEventListener?.("hide", () => {
    if (!userConfirmed) releaseAtcLock();
  });


  document.addEventListener(
      "click",
      (e) => {
        const link = e.target.closest(".countries .disclosure__link, .countries-selector .disclosure__link");
        if (!link) return;

        const targetCode = (link.dataset.value || "").toUpperCase();
        if (!targetCode) return;

        const currentCode = getCurrentCountryCode(link);
        if (targetCode === currentCode) return;

        const scope = link.closest("localization-form, form") || null;

        let form = null;
        if (scope) {
          form = scope.tagName === "FORM" ? scope : scope.querySelector("form");
        }

        const countryInput =
            scope?.querySelector('input[name="country_code"]') ||
            document.querySelector('input[name="country_code"]');

        const hasFormSubmission = Boolean(form && countryInput);

        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === "function") {
          e.stopImmediatePropagation();
        }

        if (hasFormSubmission) {

          openCountryModal(
              { type: "form", form, input: countryInput, code: targetCode },
              link
          );
        } else {
          const href = link.getAttribute("href");
          if (!href || href === "#") return;

          openCountryModal(
              { type: "url", url: href },
              link
          );
        }
      },
      { capture: true }
  );

});
